<template>
  <div class="culture">
    <div class="back-img">
      <div class="title-nav">
        <el-row :gutter="20">
          <el-col
            :class="{ active: index === isActive }"
            :key="index"
            :span="2"
            @click.native="handleClick(index)"
            v-for="(item, index) in navData"
            >{{ item.value }}</el-col
          >
        </el-row>
      </div>
    </div>
    <div class="culture-msg">
      <template v-if="isShow == 0">
        <div class="img-group">
          <div class="img-culture">
            <img
              alt="品农的目标"
              v-for="(img, i) in imgList"
              :key="i"
              :src="img"
            />
            <!-- <img alt="中国商用车融资服务领航者" src="@image/culture-msg1.png" />

            <img alt="品农的理念" src="@image/culture-msg2.png" />
            <img alt="专心只做一件事" src="@image/culture-img2.png" />

            <img alt="品农的使命" src="@image/culture-img3.png" />
            <img
              alt="提供专业、安全和创新的商用车融资服务解决方案"
              src="@image/culture-msg3.png"
            />

            <img alt="品农的愿景" src="@image/culture-msg4.png" />
            <img
              alt="成为最受信赖的商用车融资服务品牌"
              src="@image/culture-img4.png"
            /> -->
          </div>
        </div>
      </template>
      <template v-if="isShow == 1">
        <div id="certify">
          <swiper
            :options="swipersuccess"
            class="swiper-container"
            v-if="isSwiper"
          >
            <swiper-slide
              class="swiper-slide"
              v-for="(slide, i1) in swiperData"
              :key="i1"
            >
              <img :alt="slide.content" :src="slide.img" style="height:290px" />
              <div v-html="slide.content" class="slide-msg"></div>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { getCulture, getLife } from '@/api/current'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      imgList: [],
      swiperData: [],
      navData: [{ value: '品农文化' }, { value: '品农生活' }],
      isActive: 0,
      isShow: 0,
      isSwiper: false,
      swipersuccess: {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination'
          //clickable :true,
        },
        autoplay: {
          delay: 2500, //自动播放速度
          disableOnInteraction: false //鼠标移上去时是否还继续播放
        },
        on: {
          progress: function(progress) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              var slideProgress = this.slides[i].progress
              var modify = 1
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
              }
              var translate = slideProgress * modify * 260 + 'px'
              var scale = 1 - Math.abs(slideProgress) / 5
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
              slide.transform(
                'translateX(' + translate + ') scale(' + scale + ')'
              )
              slide.css('zIndex', zIndex)
              slide.css('opacity', 1)
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0)
              }
            }
          },
          setTransition: function(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition)
            }
          }
        }
      }

      // swipersuccess: {
      //   loop: true,
      //   effect: 'coverflow',
      //   slidesPerView: 3,
      //   loopedSlides: 3,
      //   centeredSlides: true,
      //   coverflowEffect: {
      //     rotate: 0,
      //     stretch: 13,
      //     depth: 40,
      //     modifier: 2,
      //     slideShadows: false
      //   },
      //   autoplay: {
      //     delay: 2500, //自动播放速度
      //     disableOnInteraction: false //鼠标移上去时是否还继续播放
      //   }
      // }
    }
  },
  //监听路由
  watch: {
    $route: function(val) {
      let name = val.query.routerPath
      if (name == 'pnwh') {
        this.isShow = 0
        this.isActive = 0
      }
      if (name == 'pnsh') {
        this.isShow = 1
        this.isActive = 1
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    let name = this.$route.query.routerPath
    if (name == 'pnwh') {
      this.isShow = 0
      this.isActive = 0
    }
    if (name == 'pnsh') {
      this.isShow = 1
      this.isActive = 1
    }
  },
  created() {
    this.init()
    this.getSwiper()
  },
  methods: {
    //品农文化
    init() {
      getCulture()
        .then(res => {
          this.imgList = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    //品农生活
    getSwiper() {
      getLife()
        .then(res => {
          this.isSwiper = true
          this.swiperData = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleClick(index) {
      this.isActive = index
      this.isShow = index
    }
  }
}
</script>

<style lang="scss" scope>
.culture {
  .back-img {
    background-image: url('../../assets/image/culture.png');
    margin-top: -62px;

    position: relative;
    .title-nav {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 85%;
      margin: auto;
      height: 65px;
      line-height: 65px;
      font-size: 16px;
      .el-row {
        background: #013165;
        .el-col {
          margin-left: 30px;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
          text-align: center;
        }
        .active {
          color: rgba(255, 255, 255, 1);
          background: rgba(13, 126, 248, 1);
          color: #fff;
        }
      }
    }
  }
  .culture-msg {
    max-width: 1350px;
    margin: 100px auto;

    .img-group {
      .img-culture {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        img {
          width: 600px;
          height: auto;
          max-width: 50%;
          max-height: 100%;
        }
      }
    }
    // .swiper-msg {
    //   box-shadow: 0px 8px 46px 4px rgba(207, 207, 207, 0.3);
    //   background: #fff;
    //   width: 450px;
    //   p {
    //     width: 500px;
    //     color: #000;
    //     padding: 12px 0px;
    //     font-size: 18px;
    //     font-weight: 400;
    //     color: rgba(51, 51, 51, 1);
    //     text-align: center;
    //   }
    // }
  }
  // .swiper-container-3d {
  //   perspective: 330px;
  // }
  // .successNav img {
  //   width: 450px;
  // }
  // .successNav .swiper-slide.swiper-slide-active img {
  //   transform: scaleX(1);
  // }
  // .swiper-slide {
  //   width: 500px; /*设为固定值*/
  //   width: auto; /*根据内容调整宽度*/
  // }
  #certify {
    position: relative;
    width: 1200px;
    margin: 0 auto;
  }

  #certify .swiper-container {
    padding-bottom: 60px;
  }

  #certify .swiper-slide {
    width: 525px;
    // height: 370px;
    background: #fff;
    box-shadow: 0 8px 30px #ddd;
  }
  #certify .imgbg {
    // background: url('../../assets/image/jzkh.jpg') no-repeat!important;
    // box-shadow: inset 60px 80px 100px #fff;
    // background-size: cover!important;
    // filter: blur(5px);
    // z-index: -1;
  }
  #certify .swiper-slide img {
    display: block;
    width: 100%;
    // filter: blur(0px)
  }
  #certify .swiper-slide p {
    // line-height: 87px;
    // height: 87px;
    padding: 25px 5px;
    text-align: center;
    color: #636363;
    font-size: 16px;
    margin: 0;
  }

  #certify .swiper-pagination {
    width: 100%;
    bottom: 20px;
  }

  #certify .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 5px;
    border: 3px solid #fff;
    background-color: #d5d5d5;
    width: 10px;
    height: 10px;
    opacity: 1;
  }

  #certify .swiper-pagination-bullets .swiper-pagination-bullet-active {
    border: 3px solid #0d7ef8;
    background-color: #fff;
  }

  #certify .swiper-button-prev {
    left: -30px;
    width: 45px;
    height: 45px;
    background: url('../../assets/image/wm_button_icon.png') no-repeat;
    background-position: 0 0;
    background-size: 100%;
    outline-color: #0000;
  }

  #certify .swiper-button-prev:hover {
    background-position: 0 -46px;
    background-size: 100%;
  }

  #certify .swiper-button-next {
    right: -30px;
    width: 45px;
    height: 45px;
    background: url('../../assets/image/wm_button_icon.png') no-repeat;
    background-position: 0 -93px;
    background-size: 100%;
    outline-color: #0000;
  }

  #certify .swiper-button-next:hover {
    background-position: 0 -139px;
    background-size: 100%;
  }
  #certify .slide-msg {
    p {
      font-size: 16px !important;
      color: #636363 !important;
      font-family: 'Microsoft YaHei', '微软雅黑' !important;

      span {
        color: #636363 !important;
        font-size: 16px !important;
        font-family: 'Microsoft YaHei', '微软雅黑' !important;
      }
    }
  }
  .swiper-button-prev:after,
  .swiper-container-rtl .swiper-button-next:after {
    display: none;
  }
  .swiper-button-next:after,
  .swiper-container-rtl .swiper-button-prev:after {
    display: none;
  }
}
</style>
